import React, { useState, useEffect, useReducer, useRef } from 'react';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';

import SVG from 'react-inlinesvg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Select } from '../../../../../../_metronic/_partials/controls';
import { toAbsoluteUrl } from '../../../../../../_metronic/_helpers';

import Numeric from '../../../../../components/Numeric';
import CheckBox from '../../../../../components/CheckBox';
import DialogBox from '../../../../../components/DialogBox';
import axios, { baseUrl } from '../../../../../../redux/my-axios';
import { initialDeliver, deliverStatusList } from '../../DeliveriesUIHelpers';
import DeliveriesItems from './Sales';
import css from './style.module.css';

const PARAM_URL = '/params';
const storageKey = 'nextDeliverDate';

function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return {
        ...state,
        deliverCode: action.payload.deliverCode,
        shipDate: action.payload.shipDate,
        saleCount: action.payload.saleCount,
        boxedCount: action.payload.boxedCount,
        totalAmount: parseFloat(action.payload.totalAmount),
        totalFee: parseFloat(action.payload.totalFee),
        deliveredDate: action.payload.deliveredDate
          ? action.payload.deliveredDate
          : '',
        sentEmail: action.payload.sentEmail === 1 ? true : false,
        note: action.payload.note,
        status: action.payload.status,
      };
    case 'setShipDate':
      return {
        ...state,
        shipDate: action.payload,
      };
    case 'setDeliveredDate':
      return { ...state, deliveredDate: action.payload };
    case 'setSentEmail':
      return {
        ...state,
        sentEmail: action.payload,
      };
    case 'setNote':
      return {
        ...state,
        note: action.payload,
      };
    case 'setSales':
      let total = 0;
      let fee = 0;
      let boxed = 0;
      let sold = 0;
      if (state.status == 0) {
        action.payload.map((item) => {
          if (item.boxed === true) {
            boxed++;
            total = total + item.totalAmount;
          }
        });
        sold = action.payload.length;
        fee = boxed * 4000;
      } else {
        total = state.totalAmount;
        fee = state.totalFee;
        sold = state.saleCount;
        boxed = state.boxedCount;
      }
      return {
        ...state,
        saleCount: sold,
        boxedCount: boxed,
        totalFee: fee,
        totalAmount: total,
      };

    default:
      throw new Error();
  }
}

const initialDialogData = {
  icon: 'question',
  iconColor: 'danger',
  title: 'Хүргэлтийн бүртгэл',
  text:
    'Хүргэлтийн бүртгэлийн өөрчлөлтөө хадгалахгүй гарахдаа итгэлтэй байна уу?',
  buttonOk: false,
  buttonYes: true,
  buttonNo: true,
  onConfirm: undefined,
};

const DeliverMain = (props) => {
  const {
    intl,
    actionsLoading,
    msg,
    dialogError,
    deliverForView,
    initialDeliver,
    btnRefSave,
    saveDeliver,
    btnRefCancel,
    onHide,
  } = props;

  //console.log('DeliverViewForm', deliverForView);
  const [state, dispatch] = useReducer(reducer, initialDeliver);
  const [err, setErr] = useState('');
  // States
  const [showConfirm, setShowConfirm] = useState(false);
  const [dialogData, setDialogData] = useState(initialDialogData);

  // Messages
  const AUTH_VALIDATION_MIN_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_LENGTH',
  });
  const AUTH_VALIDATION_MAX_LENGTH = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_LENGTH',
  });
  const AUTH_VALIDATION_MIN_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MIN_VALUE',
  });
  const AUTH_VALIDATION_MAX_VALUE = intl.formatMessage({
    id: 'GENERAL.VALIDATION.MAX_VALUE',
  });
  const AUTH_VALIDATION_REQUIRED = intl.formatMessage({
    id: 'GENERAL.VALIDATION.REQUIRED',
  });
  const DeliverCreateSchema = Yup.object().shape({
    shipDate: Yup.string().required(AUTH_VALIDATION_REQUIRED),
  });

  useEffect(() => {
    console.log('deliverForView', deliverForView);
    dispatch({ type: 'init', payload: deliverForView });
    if (deliverForView.shipDate) {
      setShipDate(deliverForView.shipDate);
    } else {
      let nextDeliverDateVal = localStorage.getItem(storageKey);

      //console.log('localStorage', nextDeliverDateVal);
      let today = new Date(new Date().toISOString().slice(0, 10));
      let nextDay = new Date();

      if (nextDeliverDateVal) {
        nextDay = new Date(nextDeliverDateVal);
      }
      //console.log('Ds: ', today, nextDay);

      if (nextDay.getTime() > today.getTime()) {
        //console.log('nextDay.getTime() > today.getTime()');
        setShipDate(nextDeliverDateVal);
      } else {
        console.log('Downloading NextShipDate from DB ...');
        axios
          .post(PARAM_URL, 'getnextdeliverdate', {
            headers: { action: 'getnextdeliverdate' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                console.log('set localStorage', response.data.data);
                localStorage.setItem(storageKey, response.data.data);
                setShipDate(response.data.data);
                break;
              default:
                console.log('error', response.data);
                break;
            }
          })
          .catch((error) => {
            console.log('error', error);
          });
      }
    }
  }, [deliverForView]);

  useEffect(() => {
    //console.log('DELIVER: ', state);
  }, [state]);

  useEffect(() => {
    setErr(dialogError);
  }, [dialogError]);

  const save = (values) => {
    console.log('Save:', values);
    setErr('');
    saveDeliver({
      ...values,
      sentEmail: values.sentEmail === true ? 1 : 0,
    });
  };

  const isChanged = () => {
    //if (JSON.stringify(initialState) != JSON.stringify(state))

    if (
      deliverForView.shipDate != state.shipDate ||
      (deliverForView.deliveredDate != state.deliveredDate &&
        deliverForView.deliveredDate &&
        state.deliveredDate !== '') ||
      deliverForView.sentEmail != (state.sentEmail === true ? 1 : 0) ||
      deliverForView.note != state.note
    ) {
      let changes = '';
      changes =
        changes +
        '\n shipDate is changed ' +
        (deliverForView.shipDate != state.shipDate);
      changes =
        changes +
        '\n deliverDate is changed ' +
        (deliverForView.deliveredDate != state.deliveredDate);
      changes =
        changes +
        '\n sentEmail is changed ' +
        (deliverForView.sentEmail != (state.sentEmail === true ? 1 : 0));
      changes =
        changes + '\n note is changed ' + (deliverForView.note != state.note);
      console.log('isChanged: changes=', changes, deliverForView, state);
      return true;
    } else return false;
  };

  const setSales = (sales) => {
    //console.log('setSales', sales);
    dispatch({ type: 'setSales', payload: sales });
  };

  const cancel = () => {
    //console.log('cancel clicked', deliverForView);
    if (!deliverForView || !deliverForView.deliverCode) exit();
    if (isChanged()) {
      setDialogData({
        ...dialogData,
        text: 'Хүргэлтийн өөрчлөлтөө хадгалахгүй гарахдаа итгэлтэй байна уу?',
        buttonOk: false,
        buttonYes: true,
        buttonNo: true,
        icon: 'question',
        iconColor: 'danger',
        onConfirm: exit,
      });
      setShowConfirm(true);
    } else exit();
  };

  const exit = () => {
    onHide();
  };

  const setDeliveredDate = (deliveredDate) => {
    dispatch({ type: 'setDeliveredDate', payload: deliveredDate });
  };

  const setShipDate = (date) => {
    //console.log('setShipDate', date);
    dispatch({
      type: 'setShipDate',
      payload: date,
    });
    //localStorage.setItem(storageKey, date);
  };

  const setSentEmail = (checked) => {
    dispatch({
      type: 'setSentEmail',
      payload: checked,
    });
  };

  const handleShip = (event) => {
    setShipDate(event.target.value);
  };

  const handleChange = (event) => {
    setDeliveredDate(event.target.value);
  };

  const setNote = (note) => {
    dispatch({
      type: 'setNote',
      payload: note,
    });
  };

  const handleFocus = (event) => event.target.select();
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={state}
        validationSchema={DeliverCreateSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ errors, touched, handleBlur, isValidating }) => (
          <>
            <Form className='form form-label-right' size='sm'>
              {err ? (
                <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{err}</div>
                </div>
              ) : (
                <div></div>
              )}
              {msg ? (
                <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
                  <div className='alert-text font-weight-bold'>{msg}</div>
                </div>
              ) : (
                <div></div>
              )}
              <div className='form-group row'>
                <div id='shipDate' className='col-3'>
                  <label> Хүргэх өдөр </label>
                  <input
                    id='shipDate'
                    type='date'
                    className='form-control form-control-sm'
                    value={state.shipDate}
                    onChange={handleShip}
                    disabled={state.sentEmail}
                  />
                  {errors.shipDate && touched.shipDate ? (
                    <div>{errors.shipDate}</div>
                  ) : null}
                </div>
                <div className='col-3'>
                  <label>Боломжит ачааны тоо</label>
                  <Numeric
                    id='saleCount'
                    name='saleCount'
                    className='form-control form-control-sm'
                    value={state.saleCount}
                    disabled={true}
                    decimalScale='0'
                    type='number'
                    fixedDecimalScale={false}
                    defaultValue='0'
                  />
                </div>
                <div className='col-3'>
                  <label>Бэлдсэн ачааны тоо</label>
                  <Numeric
                    id='boxedCount'
                    name='boxedCount'
                    className='form-control form-control-sm'
                    disabled={true}
                    value={state.boxedCount}
                    decimalScale='0'
                    type='number'
                    fixedDecimalScale={false}
                    defaultValue='0'
                    decimalSeparator=''
                  />
                </div>
                <div className='col-3'>
                  <label>Төлөв</label>
                  <Select
                    name='status'
                    className='form-control form-control-sm'
                    disabled={true}
                  >
                    {deliverStatusList.map((option) => (
                      <option
                        key={`deliverieStatusList${option.key}`}
                        value={option.key}
                      >
                        {option.value}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className='form-group row'>
                <div id='deliveredDate' className='col-3'>
                  <label>Хүргэлтэнд өгсөн огноо</label>
                  <input
                    id='deliveredDate'
                    type='date'
                    className='form-control form-control-sm'
                    value={state.deliveredDate}
                    onChange={handleChange}
                    disabled={state.sentEmail}
                  />
                </div>
                <div className='col-3'>
                  <label>Бараануудын нийт үнийн дүн</label>
                  <Numeric
                    id='totalAmount'
                    name='totalAmount'
                    className='form-control form-control-sm'
                    value={state.totalAmount}
                    disabled={true}
                    decimalScale='0'
                    type='text'
                    fixedDecimalScale={false}
                    defaultValue='0'
                    decimalSeparator=''
                  />
                </div>
                <div className='col-3'>
                  <label>Хүргэлтийн зардал</label>
                  <Numeric
                    id='totalFee'
                    name='totalFee'
                    className='form-control form-control-sm'
                    value={state.totalFee}
                    disabled={true}
                    decimalScale='0'
                    type='text'
                    fixedDecimalScale={false}
                    defaultValue='0'
                    decimalSeparator=''
                  />
                </div>
                <div className='col-3'>
                  <label>Хүргэлтийн имэйл илгээсэн</label>
                  <CheckBox
                    name='sentEmail'
                    className='form-control form-control-sm'
                    text=''
                    checked={state.sentEmail}
                    changeCheckBoxValue={(e) => {
                      setSentEmail(e);
                    }}
                  />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-12'>
                  <Field
                    name='note'
                    className='form-control form-control-sm'
                    placeholder='Тэмдэглэл'
                    as='textarea'
                    rows='3'
                    onBlur={(e) => {
                      setNote(e.target.value);
                    }}
                  />
                </div>
              </div>
              {showConfirm && (
                <DialogBox
                  openDialog={showConfirm}
                  setOpenDialog={setShowConfirm}
                  icon={dialogData.icon}
                  iconColor={dialogData.iconColor}
                  title={dialogData.title}
                  text={dialogData.text}
                  buttonOk={dialogData.buttonOk}
                  buttonYes={dialogData.buttonYes}
                  buttonNo={dialogData.buttonNo}
                  onConfirm={dialogData.onConfirm}
                ></DialogBox>
              )}
              <button
                type='submit'
                style={{ display: 'none' }}
                ref={btnRefSave}
              ></button>
              <button
                type='button'
                onClick={cancel}
                ref={btnRefCancel}
                style={{ display: 'none' }}
              >
                cancel
              </button>
            </Form>
          </>
        )}
      </Formik>

      <DeliveriesItems
        className={css.items}
        deliver={deliverForView}
        setSales={setSales}
      />
    </>
  );
};

export default injectIntl(DeliverMain);
